import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { useTranslation } from 'react-i18next';
import { NotificationService } from '../services/notification/notification.service';
import type { INotificationService } from '../services/notification/notification.service.interface';
import { resolveApiErrorMessage } from '../utils/error.utils';
import { useNotification } from './use-notification';
import { notificationQueryKeys } from './use-notifications';

export function useMarkNotificationRead() {
  const service = useInjection<INotificationService>(NotificationService);
  const queryClient = useQueryClient();
  const { showError } = useNotification();
  const { t } = useTranslation('notifications');

  return useMutation({
    mutationFn: (id: string) => service.markAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationQueryKeys.all });
    },
    onError: (err: unknown) => {
      console.error('useMarkNotificationRead error:', err);
      showError(resolveApiErrorMessage(err, t));
    },
  });
}

export function useMarkAllNotificationsRead() {
  const service = useInjection<INotificationService>(NotificationService);
  const queryClient = useQueryClient();
  const { showError } = useNotification();
  const { t } = useTranslation('notifications');

  return useMutation({
    mutationFn: () => service.markAllAsRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationQueryKeys.all });
    },
    onError: (err: unknown) => {
      console.error('useMarkAllNotificationsRead error:', err);
      showError(resolveApiErrorMessage(err, t));
    },
  });
}
